import React from "react";
import {useFormContext} from "react-hook-form";
import {NoContactInput} from "../../domain";
import {ChangeHandler} from "react-hook-form/dist/types/form";

type NumberOfContactAttemptInputProps = {
    disabled: boolean;
    error?: string | undefined;
};

const numberReg = /^\d+$/;
export const numberOnlyInput: ChangeHandler = async (event) => {
    if (isNaN(Number(event.target.value)) || !numberReg.test(event.target.value)) {
        event.target.value = '';
        return true;
    }
    return false;
};

export function NumberOfContactAttemptInput({
                                                disabled,
                                            }: NumberOfContactAttemptInputProps) {
    const {
        formState: {
            errors
        },
        watch,
        register,
    } = useFormContext<NoContactInput>();
    const dateContactResumed = watch('dateContactResumed');
    const providerWasAbleToContactClient = watch('providerWasAbleToContactClient');

    let errorCss = "";
    if (errors.numberOfContactAttempts) {
        errorCss = "border-red-500";
    }
    const registered = register('numberOfContactAttempts', {
        required: {
            value: true,
            message: 'Required'
        },
        max: {
            value: 999,
            message: 'Maximum Attempt is 999'
        },
        pattern: {
            value: /^\d+$/,
            message: 'No Decimal'
        },
        validate: {
            dateOfContactResumedAndNumberOfContact: (numContactAttempt) => {
                const num = parseInt(numContactAttempt);
                if ((dateContactResumed == null || providerWasAbleToContactClient !== 'YES') && num < 3) {
                    return "3 contact attempts are required before notifying CCS";
                }
                return true;
            }
        }
    })

    const defaultOnChange = registered.onChange;
    registered.onChange = async (event) => {
        if (await numberOnlyInput(event)) {
            return;
        }
        await defaultOnChange(event);
    };

    return (
        <div className="w-full text-black-200 pb-2 text-base items-center">
            <div className="flex items-center">
                <div className="w-2/6 text-right">
                    Number of Contact Attempts
                </div>

                <input
                    className={`w-1/6 ml-4 bg-white border border-gray-400 hover:border-atlantis-100 appearance-none ` +
                        `${errorCss} ` +
                        `p-2 rounded leading-tight focus:outline-none focus:shadow-outline ${disabled ? 'bg-gray-100 opacity-50 pointer-events-none' : ''}`}
                    autoComplete='off'
                    disabled={disabled}
                    {...registered}
                />
            </div>
            {
                errors.numberOfContactAttempts && (
                    <div className="pt-2 flex w-full">
                        <div className="w-2/6">
                        </div>
                        <div className="w-3/6 text-red-700 pl-4 pt-1 whitespace-no-wrap">
                            {errors.numberOfContactAttempts?.message}
                        </div>
                    </div>
                )
            }
        </div>
    );
}
